import { render, staticRenderFns } from "./VersionsTable.vue?vue&type=template&id=4d653434&scoped=true"
import script from "./VersionsTable.vue?vue&type=script&lang=js"
export * from "./VersionsTable.vue?vue&type=script&lang=js"
import style0 from "./VersionsTable.vue?vue&type=style&index=0&id=4d653434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d653434",
  null
  
)

export default component.exports